import { Injectable } from '@angular/core';
import { plainToClass } from 'class-transformer';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ServicesService } from '../services/services.service';
import { ProductComponent, ProductComponents } from './models/component';
import { Product, Products } from './models/product';

@Injectable({
  providedIn: 'root'
})
export class ProductService {

  constructor(private readonly http: ServicesService) {

  }

  getAllProducts(): Observable<Products> {
    return this.http.postRequest<Products>({}, 'get-product-list-full')
      .pipe(
        map(result => plainToClass(Product, result))
      );
  }

  // get-order-products
  getOrderProducts(orderId: number): Observable<ProductComponents[]> {
    return this.http.postRequest<any>({ order_id: orderId }, 'get-order-products')
      .pipe(
        map(data => {
          var productKeys = Object.keys(data.result);
          return productKeys.map(key => data.result[key]);
        }));
  }

  getComponentList(productId: number, page: number = 0, componentName: string = ''): Observable<ProductComponents> {
    const data = {
      product_id: productId,
      page: page,
      search: {
        component_name: componentName
      },
      "sort": {}
    }

    return this.http.postRequest<any>(data, 'get-component-list')
      .pipe(
        map(data => {
          const products: ProductComponents = data.result;
          return plainToClass(ProductComponent, products);
        })
      );
  }


  createProduct(data: any): Observable<any> {
    return this.http.postRequest<any>(data, 'upload-new-product');
  }
}